import { z } from "zod";

import { ERROR_MSG } from "@/constants/ErrorMessage.constant";
import { phoneNumberValidator } from "@/lib/validators";

export const LoginSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("email"),
    email: z.string().email({ message: ERROR_MSG.INVALID_EMAIL }),
    otp: z.string().max(6, { message: "OTP is required" }).optional(),
    doAgreed: z.boolean().optional(),
  }),
  z.object({
    type: z.literal("phone"),
    phone: phoneNumberValidator(true, ERROR_MSG.INVALID_PHONE),
    otp: z.string().max(6, { message: "OTP is required" }).optional(),
    doAgreed: z.boolean().optional(),
  }),
]);

export type TLoginSchema = z.infer<typeof LoginSchema>;
